var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[[_c('SiteMasthead',{attrs:{"mini":"true","title":"Tenanacy Application"}}),_c('ContentRow',[_c('ContentContainer',[_c('Form',{attrs:{"type":"Variations.Quaid.TenancyApplicationForm"}})],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }